import React from "react";
import "./abouthead.scss";
import IconHome from "../../../assets/images/9104258_home_house_homepage_icon 1.svg";
import { NavLink } from "react-router-dom";
import { Fade } from "react-reveal";
export default function AboutHead() {
  return (
    <section className="about_head">
      <div className="main-heading">
        <div className="blur"></div>
        <Fade bottom duration={600} delay={400}>
          <h1 title="About">ABOUT</h1>
        </Fade>
        <div className="flex-main">
          <Fade bottom duration={700} delay={500}>
            <div className="icon">
              <img src={IconHome} alt="HomeIcon" />
            </div>
            <div className="text-home">
              <NavLink
                to="/"
                style={({ isActive }) => ({
                  color: isActive ? "#fff" : "white",
                })}
              >
                <p title="Home">Home</p>
              </NavLink>
            </div>
          </Fade>
          <div className="text-blog">
            <Fade bottom duration={700} delay={500}>
              <p title="About">About</p>
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
}
